<template>
  <div class="performance-table">
    <b-table
      :items="tableData"
      :fields="fields"
      striped
      hover
      responsive
      class="custom-table"
    >
      <!-- Custom cell for EQ Performance column -->
      <template #cell(EQPerformance)="data">
        <div class="eq-performance-container">
          <div class="eq-performance-bar" style="width: 200px; height: 20px;">
            <div 
              class="plan-bar"
              :style="{
                width: `${(data.item.EQPerformance.PlanData)}%`,
                backgroundColor: '#E0E0E0'
              }"
            >
              <div 
                class="act-bar"
                :style="{
                  width: `${(data.item.EQPerformance.ActData / data.item.EQPerformance.PlanData * 100)}%`,
                  backgroundColor: '#7367F0'
                }"
              ></div>
            </div>
          </div>
          <div class="eq-performance-labels">
            <small class="qty-label">
              {{ data.item.EQPerformance.ActQty }} / {{ data.item.EQPerformance.PlanQty }}
            </small>
            <small class="percentage-label">
              {{ Math.round(data.item.EQPerformance.ActData / data.item.EQPerformance.PlanData * 100) }}%
            </small>
          </div>
        </div>
      </template>
    </b-table>
    <!-- 只保留錯誤訊息顯示 -->
    <div v-if="apiError" class="error-message">
      {{ apiError }}
    </div>
  </div>
</template>

<script>
import { BTable } from 'bootstrap-vue'
import ApiKan from '@/components/sag-kan-chart/js/api'

export default {
  name: 'SagPerformanceTable',
  components: {
    BTable
  },
  data() {
    return {
      fields: [
        { key: 'MachineID', label: '機台' },
        { key: 'OEE', label: 'OEE' },
        { key: 'AU', label: '稼動率' },
        { key: 'OE', label: '作業效率' },
        { key: 'PFQty', label: '良品率' },
        { key: 'EQPerformance', label: 'EQ Performance' }
      ],
      apiData: {
        Plan: [],
        Active: []
      },
      apiError: null,
      api: new ApiKan()
    }
  },
  methods: {
    getDate() {
      const today = new Date()
      const year = today.getFullYear()
      const month = String(today.getMonth() + 1).padStart(2, '0')
      const day = String(today.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    async fetchData() {
      try {
        const currentDate = this.getDate()
        console.log('正在呼叫 API...', currentDate)
        
        const requestData = {
          StartDate: String('2024-11-01'),
          EndDate: String('2024-11-27'),
          ConfigID: 1
        }
        
        const response = await this.api.apiGetEQPerformance(requestData)
        
        console.log('API 回應:', response)
        this.apiData = response
        this.apiError = null
      } catch (error) {
        console.error('API 錯誤:', error)
        this.apiError = `API 錯誤: ${error.message}`
      }
    },
    processData() {
      if (!this.apiData || !this.apiData.Plan || !this.apiData.Active) {
        console.log('無資料可處理')
        return []
      }

      const result = []
      console.log('處理資料中...')
      
      // 合併 Plan 和 Active 資料
      this.apiData.Plan.forEach(planItem => {
        const activeItem = this.apiData.Active.find(item => item.Label === planItem.Label)
        
        result.push({
          MachineID: planItem.Label,
          EQPerformance: {
            PlanData: 100, // 計畫值設為 100%
            ActData: activeItem ? (activeItem.Value / planItem.Value * 100) : 0,
            PlanQty: planItem.Value,
            ActQty: activeItem ? activeItem.Value : 0
          }
        })
      })
      
      console.log('處理後的資料:', result)
      return result
    }
  },
  computed: {
    tableData() {
      return this.processData()
    }
  },
  created() {
    console.log('元件建立，開始呼叫 API')
    this.fetchData()
  }
}
</script>

<style scoped>
.performance-table {
  width: 100%;
  margin: 1rem 0;
}

.eq-performance-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
  height: 100%;
  justify-content: center;
}

.eq-performance-bar {
  position: relative;
  background-color: #f8f8f8;
  border-radius: 4px;
  overflow: hidden;
}

.plan-bar {
  height: 100%;
  position: relative;
}

.act-bar {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
}

.eq-performance-labels {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.75rem;
  color: #6e6b7b;
}

.qty-label {
  margin-right: 8px;
}

.error-message {
  color: red;
  margin: 1rem 0;
  padding: 1rem;
  background-color: #ffebee;
  border-radius: 4px;
}

:deep(.custom-table td) {
  vertical-align: middle !important;
}
</style>
